module.exports = __webpack_public_path__ + "img/academic_weight.dd55cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/academic_weight.png
// module id = mZdL
// module chunks = 1